import { TextField } from "@mui/material";
import "./SearchBox.scss";
import SearchIcon from "@mui/icons-material/Search";

function SearchBox() {
  return (
    <div className="searchBox">
      <SearchIcon />
      <TextField
        fullWidth
        variant="outlined"
        type="text"
        placeholder="Search..."
      />
    </div>
  );
}

export default SearchBox;
